// extracted by mini-css-extract-plugin
export default {"section":"TimeLogsRulesModal_section__CjOYe","sectionTitle":"TimeLogsRulesModal_sectionTitle__liK+b","list":"TimeLogsRulesModal_list__6C0lg"};